/** The ticket look shared by deposit, withdrawal and transaction tickets: a stub, a tear line, the details. */
import type { ReactNode } from 'react';

export function TicketFrame({ head, children }: { head: ReactNode; children: ReactNode }) {
  return (
    <div className="mt-6 overflow-hidden rounded-[24px] border border-line-strong bg-bg">
      <div className="flex flex-col gap-5 p-5 md:p-6">{head}</div>
      {/* Tear line between the stub and the details, with notches cut into the sides. */}
      <div aria-hidden className="relative flex h-6 items-center">
        <span className="absolute -left-3 size-6 rounded-full border border-line-strong bg-card" />
        <span className="mx-5 flex-1 border-t-2 border-dashed border-line-strong" />
        <span className="absolute -right-3 size-6 rounded-full border border-line-strong bg-card" />
      </div>
      <div className="flex flex-col gap-5 p-5 md:p-6">{children}</div>
    </div>
  );
}
